
export enum SIDE_NAME {
  B = "buy",
  S = "sell"
}
export enum ASSET {
  BASE,
  PRICE
}

export enum STATUS {
  prepare,
  choose,
  load,
  done,
  error
}

export interface ALGORAND_TYPE {
  index: number;
  decimal: number;
  img: React.FC<React.SVGProps<SVGSVGElement>>;
  name: string;
  unit_name: string;
  reputation: number;
}

export enum SIDE {
  B = "B",
  S = "S"
}